export default {
  COMPANY_DESCRIPTION: "Deine Benefits",
  ACTIVITIES: "Deine Tätigkeiten",
  PERSPECTIVES: "Deine Perspektiven",
  CUSTOMER_DESCRIPTION: "Dein neuer Arbeitsplatz",
  FOOTER: "",
  PROFILE: "Dein Profil"
};
